import axios from "axios";
import React, {useEffect, useState} from "react";
import {useHistory, useLocation} from "react-router-dom";
import Select, {createFilter} from "react-select";
import moment from 'moment';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';
import {useTable} from "react-table";
import "jspdf-autotable";
import {
    DailyAdjustmentSummaryApi,
    downloadDailyAdjustmentSummaryApi,
    getAccountUserListApi,
    getDailyAdjustmentSummaryApi
} from "./Api";
import CustomOption from "./Utils/CustomOption";
import CustomMenuList from "./Utils/CustomMenuList";
import DataTable from "react-data-table-component";
import DataTableExtensions from "react-data-table-component-extensions";
import {useForm} from "react-hook-form";
import ConsoleHelper from "./ConsoleHelper";
import Header from "./Header";
import AppNavbar from "./Sidebar";
import Favicon from "react-favicon";
import MetaTags from "react-meta-tags";

let count = 0;
function DailyAdjustmentSummary(props) {
    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(new Date());
    const loggedUserStorage = sessionStorage.getItem('loggedUserStorage');
    const [visibleToUserSelectData, setVisibleToUserSelectData] = useState([]);
    const [selectedVisibleToUser, setSelectedVisibleToUser] = useState();
    const [accountOwnerSelectData, setAccountOwnerelectData] = useState([]);
    const [selectedAccountOwner, setSelectedAccountOwner] = useState();
    const [data, setData] = useState([]);
    const [fromDate, setFromDate] = useState();
    const [toDate, setTodate] = useState();
    const [isTableVisible, setIsTableVisible] = useState();
    const [userOptions, setUserOptions] = useState([]);
    const [selectedUser, setSelectedUser] = useState();
    const [perPage, setPerPage] = useState(10);
    const [totalRecords, setTotalRecords] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [resetUserForm, setResetUserForm] = useState(false);
    const [isDatatableLoaded, setDatatableLoaded] = useState(0);
    const history = useHistory();
    const location = useLocation();

    const {
        reset,
        formState: { errors }
    } = useForm();
    //  Internally, customStyles will deep merges your customStyles with the default styling.
    const tableStyles = {
        rows: {
            style: {
                minHeight: '30px',
                fontSize: '10px',// override the row height
            },
        },
        headCells: {
            style: {
                paddingLeft: '2px', // override the cell padding for data cells
                paddingRight: '2px',
                fontWeight: 'bold',
                textDecoration: 'underline'
            },
        },
        cells: {
            style: {
                paddingLeft: '8px',
                paddingRight: '8px',
                fontSize: '10px',
                wordBreak: 'break-word',
            },
            draggingStyle: {},
        },
        dataTableExt: {
            style: {
                Width:'40px',
            },
        },
        rdt_TableHeadRow: {
            backgroundColor : 'red',
        }
    };

    const alignBox = {
        display: "flex",
        justifyContent: "space-around"
    };

    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            minHeight: '30px',
            height: '30px',
            boxShadow: state.isFocused ? null : null,
        }),

        valueContainer: (provided, state) => ({
            ...provided,
            height: '30px',
            padding: '0 6px'
        }),

        input: (provided, state) => ({
            ...provided,
            margin: '0px',
            width: "9vw",
        }),
        indicatorSeparator: state => ({
            display: 'none',
        }),
        indicatorsContainer: (provided, state) => ({
            ...provided,
            height: '30px',
        }),
    };


    const datacolumns = [

        {
            name: 'Terminal ',
            selector: row => row.terminal,
            sortable: true,
        },
        {
            name: 'Account Name ',
            selector: row => row.accountName,
            sortable: true,
        },
        {
            name: 'RTA ',
            selector: row => row.rta,
            sortable: true,
        },
        {
            name: 'Amount',
            selector: row => '$'+row.amount.toLocaleString(),
            sortable: true,
        },
        {
            name: 'Description',
            selector: row =>  row.description,
            sortable: true,
        }
    ];



    const onRowClicked = row => {
        history.push({
            pathname: "/accountManager/properties",
            search: `rta=${row.rta}&AccountID=${row.accountID}`,
        });
        ConsoleHelper(row)
        //setData(updatedData);
    };

    useEffect(() => {

        const getUsers = async () => {
            console.log(" GET USERS BY LIST")

            const result = null;
            //const result = await axios.get(`${getAccountUserListApi}?paramUserID=${loggedUserStorage}`);
            console.log(" ---- ",result)

            //setUserOptions(result?.data?.response);
            setSelectedUser({
                label: loggedUserStorage,
                value: loggedUserStorage,
            });

        };

        getUsers();
        return () => {
            setData([]);
            setVisibleToUserSelectData([]);
            setAccountOwnerelectData([]);
            setUserOptions([]);

        };
    }, [location]);

    const handleStartDate = (start, end) => {
        console.log(start.format('YYYY-MM-DD  HH:mm:ss'))
        setStartDate(start.format('YYYY-MM-DD  HH:mm:ss'));
        setFromDate(start.format('YYYY-MM-DD  HH:mm:ss'))
    };

    const handleEndDate = (start, end) => {
        console.log("====== ",end.format('YYYY-MM-DD  HH:mm:ss'))
        //setStartDate(start);
        setEndDate(end.format('YYYY-MM-DD  HH:mm:ss'));
        setTodate(end.format('YYYY-MM-DD  HH:mm:ss'));
    };
    useEffect(() => {
        const terminalId = location?.search?.split("=")?.[1];
        const getLocationandTerminals = async () => {
            const selectedUserByDefault = (typeof selectedUser?.userId == "undefined") ? loggedUserStorage : selectedUser?.userId;
            var feed = {userId: loggedUserStorage, label: loggedUserStorage, value: loggedUserStorage};
            console.log(" Logged In user",selectedUserByDefault)

            const resultUser = await axios.get(`${getAccountUserListApi}?paramUserID=${selectedUserByDefault}`);
            //console.log(" GET LOCATION BY USERID BY SELECTED USER",resultUser?.data)
            resultUser?.data.unshift(feed);
            setVisibleToUserSelectData(resultUser?.data);
            setAccountOwnerelectData(resultUser?.data)
            if(resultUser?.data != undefined) {
                setSelectedVisibleToUser({
                    label: loggedUserStorage,
                    value: loggedUserStorage,
                });
                setSelectedAccountOwner({
                    label: "All",
                    value: "-1",
                });
            }else{
                setSelectedVisibleToUser([])
            }
        };

        getLocationandTerminals();
        return () => {
            setVisibleToUserSelectData([]);
        };
    }, [resetUserForm]);

    const handleReset = async (e) => {
        console.log(" resetting form")
        setResetUserForm(true);
    };


    const retrieveReport = async (e) => {
        console.log(" getting report ")
        //e.preventDefault();
        axios({
            url: `${downloadDailyAdjustmentSummaryApi}?fromDate=${(typeof fromDate === 'undefined')? moment().startOf('day').add(-1, 'day').format('YYYY-MM-DD  HH:mm:ss'): fromDate}&toDate=${(typeof toDate === 'undefined')?  moment().startOf('day').format('YYYY-MM-DD  HH:mm:ss'): toDate}&paramUserID=${(typeof selectedVisibleToUser?.value === 'undefined')? moment().startOf('day').add(-1, 'day').format('YYYY-MM-DD  HH:mm:ss'): selectedVisibleToUser?.value}`, //your url
            method: "GET",
            responseType: "blob", // important
        }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "DailyAdjustmentSummary.xls"); //or any other extension
            document.body.appendChild(link);
            link.click();
        });
    };
        const handleGetReport = async () => {
           // try {
                console.log(" paramOwner ",selectedVisibleToUser?.value)
                console.log("fromDate",fromDate)
               console.log(toDate,"------",fromDate)
                const result = await axios.get(`${DailyAdjustmentSummaryApi}?fromDate=${(typeof fromDate === 'undefined')? moment().startOf('day').add(-1, 'day').format('YYYY-MM-DD  HH:mm:ss'): fromDate}&toDate=${(typeof toDate === 'undefined')? moment().startOf('day').format('YYYY-MM-DD  HH:mm:ss'): toDate}&paramUserID=${(typeof selectedVisibleToUser?.value === 'undefined')? '-1': selectedVisibleToUser?.value}`,{
                mode: 'no-cors' // 'cors' by default
            });
                console.log(" get result data ",result?.data);
                setTotalRecords(result?.data?.length);
               setData(result?.data);
                setIsTableVisible(true);
        };



    return (
        <div className="tab-pane" id="tb_terminal_mgmt" role="tabpanel">
            <body data-sidebar="colored">
            <div id="layout-wrapper">
                <Header/>
                <AppNavbar/>
            </div>
            <div className="main-content">
                <Favicon url='https://passporttechnology.com/images/base/favicon-16x16.png' />
                <MetaTags>
                    <title>DataStream Version 2.0</title>
                    <meta name="description" content="Some description." />
                    <meta property="og:title" content="DataStream Version 2.0" />
                </MetaTags>
                <div className="page-content">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-12">
                                <div className="page-title-box d-flex align-items-center justify-content-between">
                                    <h4 className="mb-0">Daily Adjustment Dashboard</h4>
                                </div>
                            </div>
                        </div>
        <div>
            <div className="row">
                <div className="col-xl-12">
                    <div className="card">
                        <div className="card-body">
                            <div className="tab-content p-3 text-muted">
                                <div className="form-group" style={alignBox}>
                <div className="col col-md-4">
                    <div className="d-flex justify-content-between">
                            <label  className="control-label">From Date: </label>
                        <div>
                            <DateRangePicker
                                initialSettings={{
                                    timePicker: true,
                                    singleDatePicker: true,
                                    //showDropdowns: true,
                                           startDate: moment().startOf('day').add(-1, 'day'),
                                              //endDate: moment().startOf('hour').add(32, 'hour').toDate(),
                                              locale: {
                                                format: 'YYYY-MM-DD hh:mm A',
                                              },
                                            }}
                                onCallback={handleStartDate}
                            >
                                <input type="text" className="form-control" />
                            </DateRangePicker>
                        </div>
                    </div>
                </div>
                <div className="col col-md-4">
                    <div className="d-flex justify-content-between ">
                        <label  className="control-label">To Date: </label>
                        <div>
                           {/* <input type="datetime-local" id="toDate" onFocus="this.showPicker()" className="form-control form-control-sm" style={{ background: "content-box",width: "12.5vw" }} onChange={(e) =>
                                setTodate(
                                    (e.target.value)
                                )
                            }/>*/}

                           { <DateRangePicker
                               initialSettings={{
                                   timePicker: true,
                                   singleDatePicker: true,
                                   //showDropdowns: true,
                                   startDate:  moment().startOf('day'),
                                   //endDate: moment().startOf('hour').toDate(),
                                   locale: {
                                       format: 'YYYY-MM-DD hh:mm A',
                                   },
                               }}
                                onCallback={handleEndDate}
                            >
                                <input type="text" className="form-control" />
                            </DateRangePicker>}
                        </div>
                    </div>
                </div>
                <div className="col col-md-4">
                        <div className="d-flex justify-content-between align-items-center">
                            <label  className="control-label">User:</label>
                            <div>
                                <Select
                                    options={visibleToUserSelectData}
                                    value={selectedVisibleToUser}
                                    onChange={(e) => setSelectedVisibleToUser(e)}
                                    filterOption={createFilter({ ignoreAccents: false })}
                                    captureMenuScroll={false}
                                    components={{ Option: CustomOption, MenuList: CustomMenuList }}
                                    styles={customStyles}
                                />
                            </div>
                        </div>
                </div>
                                </div>
                                <div className="row d-flex justify-content-center mt-1 align-items-center">
                <span
                    className="btn btn-primary"
                    role="button"
                    onClick={() => handleGetReport()}
                >
Generate Report
        </span>
                                    <span className="input-group-text ml-4" role="button" onClick={() => retrieveReport()}>
            Export to Excel
        </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/*  */}
            <div className="mt-3">
                {isTableVisible &&<DataTableExtensions
                    columns={datacolumns}
                    data={data}
                    print={false}
                    export={true}
                >

                    <DataTable
                        columns={datacolumns}
                        data={data}
                        noHeader
                        pagination
                        highlightOnHover
                        pointerOnHover
                        paginationServer
                        paginationTotalRows={totalRecords}
                        paginationPerPage={perPage}
                        paginationComponentOptions={{
                            noRowsPerPage: true
                        }}
                        onChangePage={page => setCurrentPage(page)}
                        customStyles={tableStyles}
                    />
                </DataTableExtensions>}
            </div>
        </div>
                    </div>
                </div>
            </div>
            </body>
        </div>
    );
}

export default DailyAdjustmentSummary;
